import React, { CSSProperties } from 'react';
import ContentType from 'models/types/ts/contentType';
import SectionType from 'models/types/ts/sectionType';
import ReactMarkdown from 'utils/markdown'
import { debounce } from 'lodash';
import { Visibility } from 'layouts'
import style from './ContentHighlightPanel.module.scss'

const getGridColumnTemplate = (isDesktop: boolean, numberOfItems: number): string => {
    if (!isDesktop) {
        return 'auto'
    }
    return numberOfItems % 3 === 1 ? 'auto auto' : 'auto auto auto';
}


export const Card = ({ content, transitionDelay }: {content: ContentType; transitionDelay: number}): JSX.Element => {
    const { headline } = content
    return <Visibility direction="fadeUp" transitionDelay={`${transitionDelay}s`} style={{transitionDuration: '2s'}}>
        <div className={style.card}>
            <h3>{headline}</h3>
            <ReactMarkdown source={content.body} />
        </div>
    </Visibility>
}


export const ContentHighlightPanel = ({ section, color="#3399FF" }: { section: SectionType, color?: string } ): JSX.Element => {
    const cardListRef = React.useRef(null)
    const imageRef = React.useRef(null)
    const isDesktopWidth = window.visualViewport.width > 992

    const [cardListHeight, setCardListHeight] = React.useState(0)
    const [imageHeight, setImageHeight] = React.useState(0)

    const updateDimensions = debounce(() => {
        if(cardListRef.current) {
            setCardListHeight(cardListRef.current.offsetHeight)
        }
        if (imageRef.current) {
            setImageHeight(imageRef.current.offsetHeight)
        }
    }, 50);
    
    React.useEffect(() => {
        window.addEventListener("resize", updateDimensions);
        updateDimensions();
        return () => {
            window.removeEventListener("resize", updateDimensions);
        };
    }, []);

    const { headline, imageFile, contentCollection: { items } } = section

    return <div className={style.inFocus} style={{marginBottom: isDesktopWidth ? cardListHeight - (imageHeight / 2) : 0, '--dlp-in-focus-color': color} as CSSProperties}>
        <Visibility style={{transitionDuration: '2s'}} direction="fadeUp" transitionDelay="0s">
            <h3 className={style.headline}>{headline}</h3>
        </Visibility>
        <div className={style.contentWrapper}>
            <div ref={imageRef} className={style.backgroundImage}>
                <img src={imageFile.url} alt={imageFile.description} />
            </div>
            <div ref={cardListRef} style={{gridTemplateColumns: getGridColumnTemplate(isDesktopWidth, items.length)}} className={style.cardContainer}>
                {items.map((content, index)=> {
                    return <Card content={content} transitionDelay={0.5 + (index / 10)} />
                })}
            </div>
        </div>
    </div>
}